/**
 * Ячейка даты (§5.2, тип «Дата»): показ `dd.mm.yyyy`, редактор — нативный
 * `input[type=date]` (он же даёт календарь и локальный формат ввода).
 * Пустое значение допустимо.
 */
import { useEffect, useRef, useState } from 'react'
import { Input } from '../../../../components/index.js'
import { tableTexts as t } from '../../texts.table.js'
import { dateView } from '../values.js'
import type { CellProps } from './CellBox.js'

export function DateCell(props: CellProps) {
  const { column, cell, editing, readOnly, write, stepAfterCommit, commitAndRight, closeEditor } = props
  const published = typeof cell.value === 'string' ? cell.value.slice(0, 10) : ''
  const [value, setValue] = useState(published)
  const latest = useRef(value)

  useEffect(() => {
    if (!editing) return
    setValue(published)
    latest.current = published
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editing])

  if (!editing || readOnly) {
    if (cell.empty) return <span className="cell__empty">{t.empty.dash}</span>
    return <span className="cell__value">{dateView(cell.value)}</span>
  }

  const flush = () => {
    const next = latest.current === '' ? null : latest.current
    if (next !== (published === '' ? null : published)) write(next)
  }

  return (
    <div
      className="cell__editor"
      onKeyDown={(event) => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeEditor(); return }
        if (event.key === 'Enter') {
          event.preventDefault(); event.stopPropagation()
          flush()
          stepAfterCommit(event.shiftKey ? -1 : 1)
          return
        }
        if (event.key === 'Tab') {
          event.preventDefault(); event.stopPropagation()
          flush()
          commitAndRight()
        }
      }}
    >
      <Input
        autoFocus
        type="date"
        size="cell"
        value={value}
        aria-label={column.title}
        onChange={(event) => { setValue(event.target.value); latest.current = event.target.value }}
        onBlur={flush}
      />
    </div>
  )
}
